import {KeyerUserType} from 'Users/models/User/AppEntry/KeyerUser';

export enum AppEntryRole {
  Undetermined,
  Keyer,
}

export class UndeterminedAppEntryUserType {
  public readonly key = 'UndeterminedAppEntryUserType';
  public readonly appEntryRole = AppEntryRole.Undetermined;
}

export class InvalidAppEntryUserType {
  public readonly key = 'InvalidAppEntryUserType';
  public readonly value = new UndeterminedAppEntryUserType();
}

export class ValidAppEntryUserType {
  public readonly key = 'ValidAppEntryUserType';

  constructor(public readonly value: KeyerUserType) {}
}

export type AppEntryUserType = ValidAppEntryUserType | InvalidAppEntryUserType;

type AppEntryUserTypeOptions<TReturn> = {
  Keyer: (keyerUserType: KeyerUserType) => TReturn;
  Undetermined: () => TReturn;
};

export const matchAppEntryUserType = <TReturn>(
  appEntryUserType: ValidAppEntryUserType['value'] | InvalidAppEntryUserType['value'],
  options: AppEntryUserTypeOptions<TReturn>
): TReturn => {
  switch (appEntryUserType.key) {
    case 'UndeterminedAppEntryUserType':
      return options.Undetermined();
    case 'KeyerUserType':
      return options.Keyer(appEntryUserType);
  }
};
